import { canInitializeDatadog } from "@/plugins/datadog/datadogHelper.ts"
import { datadogLogs, StatusType } from "@datadog/browser-logs"

export default {
  log(name: string, metadata = {}, level: StatusType = "info") {
    if (canInitializeDatadog()) {
      datadogLogs.logger[level](name, metadata)
    }
  },
}
